module.exports = __webpack_public_path__ + "static/media/servicesBackground.35f70950.jpeg";